<div class="multiselect-dropdown-container">
  <ng-multiselect-dropdown [placeholder]="'Select all that apply'" [(ngModel)]="selectedYearObjects" name="fiscalYear" [data]="affiliations"  [disabled]="disabled"
                           [settings]="dropdownSettings" (onDeSelectAll)="onSelectAll($event)" (onSelectAll)="onSelectAll($event)" (onSelect)="onSelectionChange($event, 'select')" (onDeSelect)="onSelectionChange($event, 'deselect')">
  </ng-multiselect-dropdown>

</div>
